<template>
  <div>
    <div class="index-module_articleWrap_2Zphx">
      <div  class="zhemo">巴菲特最著名的演讲:价值投资为什么能够持续战胜市场？</div>
      <p class=index-module_textWrap_3ygOc style="display: none">
        来源<span unicode="ff1a" class="biaodian cjk bd-end bd-jiya"
          ><span>：</span></span
        >雪球App<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >作者<span unicode="ff1a" class="biaodian cjk bd-end bd-jiya"
          ><span>：</span></span
        >
        WithEric<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya bd-consecutive"
          ><span>，</span></span
        ><span
          unicode="ff08"
          class="biaodian cjk bd-open bd-jiya bd-consecutive end-portion"
          prev="bd-end bd-cop"
          ><span>（</span></span
        >https://xueqiu.com/5208862748/109138210<span
          unicode="ff09"
          class="biaodian cjk bd-close bd-end bd-jiya"
          ><span>）</span></span
        >
      </p>
      <p class=index-module_textWrap_3ygOc>
        价值投资策略最终要归根于本杰明-格雷厄姆<span
          unicode="ff08"
          class="biaodian cjk bd-open bd-jiya"
          ><span>（</span></span
        >BenjaminGraham<span
          unicode="ff09"
          class="biaodian cjk bd-close bd-end bd-jiya"
          ><span>）</span></span
        >的思想<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >1934年年底<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他与戴维-多德<span
          unicode="ff08"
          class="biaodian cjk bd-open bd-jiya"
          ><span>（</span></span
        >David Dodd<span
          unicode="ff09"
          class="biaodian cjk bd-close bd-end bd-jiya"
          ><span>）</span></span
        >合作完成了他酝酿已久的<span
          unicode="300a"
          class="biaodian cjk bd-open bd-jiya"
          ><span>《</span></span
        >证券分析<span
          unicode="300b"
          class="biaodian cjk bd-close bd-end bd-jiya bd-consecutive"
          ><span>》</span></span
        ><span
          unicode="ff08"
          class="biaodian cjk bd-open bd-jiya bd-consecutive end-portion"
          prev="bd-close bd-end"
          ><span>（</span></span
        >Security Analysis<span
          unicode="ff09"
          class="biaodian cjk bd-close bd-end bd-jiya bd-consecutive"
          ><span>）</span></span
        ><span
          unicode="3002"
          class="
            biaodian
            cjk
            bd-end bd-cop bd-hangable bd-jiya bd-consecutive
            end-portion
          "
          prev="bd-close bd-end"
          ><span>。</span></span
        >这部划时代的著作标志着证券分析业和价值投资思想的诞生<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >这本巨著在过去70年间共发行了五版<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >被誉为投资者的<span unicode="201c" class="biaodian cjk bd-open punct"
          >“</span
        >圣经<span unicode="201d" class="biaodian cjk bd-close bd-end punct"
          >”</span
        ><span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >
      </p>
      <p class=index-module_textWrap_3ygOc>
        纽约证券分析协会强调<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >格雷厄姆<span unicode="201c" class="biaodian cjk bd-open punct"
          >“</span
        >对于投资的意义就像欧几里得对于几何学<span
          unicode="3001"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>、</span></span
        >达尔文对于生物进化论一样重要<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >格雷厄姆<span unicode="201c" class="biaodian cjk bd-open punct"
          >“</span
        >给这座令人惊叹而为之却步的城市--股票市场绘制了第一张可以依赖的地图<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他为价值投资奠定了方法论的基础<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >而在此之前<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >股票投资与赌博几乎毫无差别<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >价值投资没有格雷厄姆<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >就如同共产主义没有马克思--原则性将不复存在<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        ><span unicode="201d" class="biaodian cjk bd-close bd-end punct"
          >”</span
        >人们通常认为是格雷厄姆确立了证券分析的原则<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >所以格雷厄姆被尊称为现代证券分析之父<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >
      </p>
      <p class=index-module_textWrap_3ygOc>
        1984年<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >在哥伦比亚大学纪念格雷厄姆与多德合著的<span
          unicode="300a"
          class="biaodian cjk bd-open bd-jiya"
          ><span>《</span></span
        >证券分析<span
          unicode="300b"
          class="biaodian cjk bd-close bd-end bd-jiya"
          ><span>》</span></span
        >出版50周年的庆祝活动中<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >巴菲特--这位格雷厄姆在哥伦比亚大学的投资课上唯一给了<span
          unicode="201c"
          class="biaodian cjk bd-open punct"
          >“</span
        >A+<span unicode="201d" class="biaodian cjk bd-close bd-end punct"
          >”</span
        >的最优秀的学生进行了一次演讲<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他在演讲中回顾了50年来格雷厄姆的追随者们采用价值投资策略持续战胜市场的无可争议的事实<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >总结归纳出价值投资策略的精髓<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >在投资界具有非常大的影响力<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >可以这样说<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >读懂了巴菲特的这篇演讲<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >就能够抓住价值投资的本质<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >弄清价值的内涵<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >让我们一起来聆听巴菲特这位当代最伟大的价值投资大师的演讲吧<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >
      </p>
      <p class="index-module_textWrap_3ygOc szhuang">
        <b
          >价值投资过时了吗<span
            unicode="ff1f"
            class="biaodian cjk bd-end bd-jiya"
            ><span>？</span></span
          ></b
        >
      </p>
      <p class=index-module_textWrap_3ygOc>
        格雷厄姆和多德<span unicode="201c" class="biaodian cjk bd-open punct"
          >“</span
        >寻找价值相对于价格具有一个显著的安全边际<span
          unicode="201d"
          class="biaodian cjk bd-close bd-end punct"
          >”</span
        >的证券分析方法难道已经过时了吗--许多教授在他们编写的大部头教科书中都作出这一论断<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他们口口声声地宣称股票市场是有效的<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >也就是说股价反映了所有关于公司发展前景和经济状况的所有信息<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >这些理论家们声称<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >由于聪明的股票分析师利用了所有可获取的信息进行分析判断<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >从而使股价总是正确无误地保持在合理的水平<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >因此根本不存在价值被市场低估的股票<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >至于那些年复一年击败市场的投资者<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >只不过是类似彩票连续中奖的少数幸运儿<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >一位教授在他编写的当今十分流行的教科书中写道<span
          unicode="ff1a"
          class="biaodian cjk bd-end bd-jiya"
          ><span>：</span></span
        ><span unicode="201c" class="biaodian cjk bd-open punct">“</span
        >如果股价完全反映了所有可获取的信息<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >这些投资技巧将毫无用处<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        ><span unicode="201d" class="biaodian cjk bd-close bd-end punct"
          >”</span
        >
      </p>
      <p class=index-module_textWrap_3ygOc>
        哈哈<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >也许如此<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >但我想向大家介绍一群年复一年击败标准普尔500股票指数的投资者<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他们的经历无可辩驳地表明<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >那种认为他们持续战胜市场只是偶然事件的简单看法是很难成立的<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >我们必须深入探究其根本原因<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >之所以如此<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >一个关键事实是<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >这些股市大赢家我都非常熟悉<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >并很早就被公认为超级投资者<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >其中成名最晚的那位也在15年前就名扬一时<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >如果事实并非如此<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >我只是最近搜索了成千上万的投资记录<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >从中选出几个业绩优秀的人在此向各位介绍<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >那么<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >你听到此处就可以把我赶走了<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >我要补充说明的是<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他们的投资业绩记录都已经过严格的审计<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >另外<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >我还要补充说明一下<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >我还认识许多选择这些投资管理人的客户<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他们这些年来获得的投资收益与这些投资管理人公开的投资业绩记录完全相符<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >
      </p>
      <p class="index-module_textWrap_3ygOc szhuang">
        <b
          ><span unicode="201c" class="biaodian cjk bd-open punct">“</span
          >全美抛硬币猜正反面大赛<span
            unicode="201d"
            class="biaodian cjk bd-close bd-end punct"
            >”</span
          ></b
        >
      </p>
      <p class=index-module_textWrap_3ygOc>
        在我们开始探究这些投资大师持续战胜市场之谜之前<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >我想先请在座各位跟我一起来观赏一场想象中的全美抛硬币猜正反面大赛<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >假设我们动员全美国 2.25亿人明天早上每人赌1美元<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >猜一下抛出的一个硬币落到地上是正面还是反面<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >赢家则可以从输家手中赢得1美元<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >每一天输家被淘汰出局<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >赢家则把所赢得的钱全部投入<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >作为第二天的赌注<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >经过十个早上的比赛<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >将大约有22万名美国人连续获胜<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他们每人可赢得略微超过1,000美元的钱<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >
      </p>
      <p class=index-module_textWrap_3ygOc>
        人类的虚荣心本性会使这群赢家们开始有些洋洋得意<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >尽管他们想尽量表现得十分谦虚<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >但在鸡尾酒会上<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >为了吸引异性的好感<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他们会吹嘘自己在抛硬币上如何技术高超<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >如何天才过人<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >
      </p>
      <p class=index-module_textWrap_3ygOc>
        如果赢家从输家手里得到相应的赌注<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >再过十天<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya bd-consecutive"
          ><span>，</span></span
        ><span
          unicode="ff08"
          class="biaodian cjk bd-open bd-jiya bd-consecutive end-portion"
          prev="bd-end bd-cop"
          ><span>（</span></span
        >将会有215位连续猜对20次硬币的正反面的赢家<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >通过这一系列较量<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-jiya bd-consecutive"
          ><span>，</span></span
        ><span
          unicode="ff09"
          class="
            biaodian
            cjk
            bd-close bd-end bd-jiya bd-consecutive
            end-portion
          "
          prev="bd-end bd-cop"
          ><span>）</span></span
        >他们每个人用1美元赢得了100万美元之多<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >215个赢家赢得225个百万美元<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >这也意味着其他输家输掉了225百万美元<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >
      </p>
      <p class=index-module_textWrap_3ygOc>
        这群刚刚成为百万富翁的大赢家们肯定会高兴到发昏<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他们很可能会写一本书--<span
          unicode="201c"
          class="biaodian cjk bd-open punct"
          >“</span
        >我如何每天只需工作30秒就在20天里用1美元赚到100万美元<span
          unicode="201d"
          class="biaodian cjk bd-close bd-end punct"
          >”</span
        ><span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >更有甚者<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他们可能会在全国飞来飞去<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >参加各种抛硬币神奇技巧的研讨会<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >借机嘲笑那些满脸疑问的大学教授们<span
          unicode="ff1a"
          class="biaodian cjk bd-end bd-jiya"
          ><span>：</span></span
        ><span unicode="201c" class="biaodian cjk bd-open punct">“</span
        >如果这种事根本不可能发生<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >难道我们这215个大赢家是从天下掉下来的吗<span
          unicode="ff1f"
          class="biaodian cjk bd-end bd-jiya"
          ><span>？</span></span
        ><span unicode="201d" class="biaodian cjk bd-close bd-end punct"
          >”</span
        >
      </p>
      <p class=index-module_textWrap_3ygOc>
        对此<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >一些工商管理学院的教授可能会恼羞成怒<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他们会不屑一顾地指出<span
          unicode="ff1a"
          class="biaodian cjk bd-end bd-jiya"
          ><span>：</span></span
        >
        即使是2.25亿只大猩猩参加同样的抛硬币比赛<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >结果毫无二致<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >只不过赢家是连续猜对20次的215只狂妄自大的大猩猩而已<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >但我对此却不敢苟同<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >在我下面所说的案例中的赢家们确实有一些明显的与众不同之处<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >我所说的案例如下<span
          unicode="ff1a"
          class="biaodian cjk bd-end bd-jiya bd-consecutive"
          ><span>：</span></span
        ><span
          unicode="ff08"
          class="biaodian cjk bd-open bd-jiya bd-consecutive end-portion"
          prev="bd-end"
          ><span>（</span></span
        >1<span unicode="ff09" class="biaodian cjk bd-close bd-end bd-jiya"
          ><span>）</span></span
        >参加比赛的2.25亿只猩猩大致像美国人口一样分布在全国各地<span
          unicode="ff1b"
          class="biaodian cjk bd-end bd-jiya"
          ><span>；</span></span
        >
        <span unicode="ff08" class="biaodian cjk bd-open bd-jiya"
          ><span>（</span></span
        >2<span unicode="ff09" class="biaodian cjk bd-close bd-end bd-jiya"
          ><span>）</span></span
        >
        经过20天比赛后<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >只剩下215位赢家<span
          unicode="ff1b"
          class="biaodian cjk bd-end bd-jiya bd-consecutive"
          ><span>；</span></span
        ><span
          unicode="ff08"
          class="biaodian cjk bd-open bd-jiya bd-consecutive end-portion"
          prev="bd-end"
          ><span>（</span></span
        >3<span unicode="ff09" class="biaodian cjk bd-close bd-end bd-jiya"
          ><span>）</span></span
        >如果你发现其中40家赢家全部来自奥马哈的一家十分独特的动物园<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >那么<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >你肯定会前往这家动物园找饲养员问个究竟<span
          unicode="ff1a"
          class="biaodian cjk bd-end bd-jiya"
          ><span>：</span></span
        >
        他们给猩猩喂的是什么食物<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他们是否对这些猩猩进行过特殊的训练<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >这些猩猩在读些什么书以及其他种种你认为可能的原因<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >换句话说<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >如果那些成功的赢家不同寻常地集中<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >你就会想弄明白到底是什么不同寻常的因素导致了赢家不同寻常地集中<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >
      </p>
      <p class=index-module_textWrap_3ygOc>
        科学探索一般遵循完全相同的模式<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >如果你试图分析一种罕见的癌症的致病原因<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >比如每年在美国有1,500起病例<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >你发现其中400起发生在蒙大拿
        <span unicode="ff08" class="biaodian cjk bd-open bd-jiya"
          ><span>（</span></span
        >Montana<span
          unicode="ff09"
          class="biaodian cjk bd-close bd-end bd-jiya"
          ><span>）</span></span
        >的几个矿区小镇上<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >你会非常仔细地研究当地的水质<span
          unicode="3001"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>、</span></span
        >感染病人的职业特征或者其他因素<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >因为你很清楚<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >一个面积很小的地区发生400起病例绝不可能是偶然的<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >你并不需要一开始就知道什么是致病原因<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >但你必须知道如何去寻找可能的致病原因<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >
      </p>
      <p class="index-module_textWrap_3ygOc szhuang"><b>格雷厄姆和多德价值投资部落</b></p>
      <p class=index-module_textWrap_3ygOc>
        当然<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >我和各位一样认为<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >事实上<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >除了地理因素之外<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >还有很多其他因素会导致赢家非常地集中<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >除了地理因素以外<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >还有一种因素<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >我称之为智力因素<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >我想你会发现<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >在投资界为数众多的大赢家们却不成比例地全部来自于一个小小的智力部落--格雷厄姆和多德部落<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >这种赢家集中的现象根本无法用偶然性或随机性来解释<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >最终只能归因于这个与众不同的智力部落<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >
      </p>
      <p class=index-module_textWrap_3ygOc>
        可能存在一些原因<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >使这种赢家非常集中的现象其实不过是件平凡小事<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >可能100个赢家只不过是简单地模仿一位非常令人信服的领导者的方法来猜测抛硬币的正反面<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >当领导者猜正面朝上时<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >100个追随者一起随声附和<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >如果这位领导者是最后胜出的215个赢家中的一员<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >那么<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >认为其中100个只会随声附和的人获胜是由于同样的智力因素的分析就变得毫无意义<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >你不过是把区区1个成功案例误认为是100个不同的成功案例<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >与此类似<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >假设你生活在一个家长强大统治下的社会中<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >为方便起见<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >假设每个美国家庭有10位成员<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >我们进一步假设家长的统治力非常强大<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >当2.25亿人第一天出门进行比赛时<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >每个家庭成员都唯父命是从<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >父亲怎么猜<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >家人就怎么猜<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >那么<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >在20天比赛结束后<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >你会发现215个赢家其实只不过是来自于21.5个不同的家庭<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >那些天真的家伙将会说<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >
        这种情形表明猜硬币的成功原因可以用遗传因素的强大力量来解释<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >但这种说法其实毫无意义<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >因为这215位赢家们并非各不相同<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >其实真正的赢家是21.5个随机分布<span
          unicode="3001"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>、</span></span
        >各不相同的家庭<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >
      </p>
      <p class=index-module_textWrap_3ygOc>
        我想要研究的这一群成功投资者<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他们拥有一位共同的智力族长--本﹒格雷厄姆<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >但是这些孩子长大离开这个智力家族后<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >却是根据非常不同的方法来进行投资的<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >他们居住在不同的地区<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >买卖不同的股票和企业<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >但他们总体的投资业绩绝非是因为他们根据族长的指示所作出完全相同的投资决策<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >族长只为他们提供了投资决策的思想理论<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >每位学生都以自己的独特方式来决定如何运用这种理论<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >
      </p>
      <p class=index-module_textWrap_3ygOc>
        来自<span unicode="201c" class="biaodian cjk bd-open punct">“</span
        >格雷厄姆与多德部落<span
          unicode="201d"
          class="biaodian cjk bd-close bd-end punct"
          >”</span
        >的投资者共同拥有的智力核心是<span
          unicode="ff1a"
          class="biaodian cjk bd-end bd-jiya"
          ><span>：</span></span
        >
        寻找企业整体的价值与代表该企业一小部分权益的股票市场价格之间的差异<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >实质上<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他们利用了二者之间的差异<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >却毫不在意有效市场理论家们所关心的那些问题--股票应该在星期一还是星期二买进<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >在1月份还是7月份买进等等<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >简而言之<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >企业家收购企业的投资方式<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >正是追随格雷厄姆与多德的投资者在购买流通股票时所采用的投资方式--我十分怀疑有多少企业家会在收购决策中特别强调交易必须在一年中的某个特定月份或一周中的某个特定日子进行<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >如果企业整体收购在星期一或星期五进行没有任何差别<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >那么<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >我无法理解那些学究们为什么会花费大量的时间和精力研究代表该企业一小部分股权的股票交易时间的不同将会对投资业绩有什么影响<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >追随格雷厄姆与多德的投资者根本不会浪费精力去讨论什么Beta<span
          unicode="3001"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>、</span></span
        >资本资产定价模型<span
          unicode="3001"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>、</span></span
        >不同证券投资报酬率之间的协方差<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他们对这些东西丝毫也不感兴趣<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >事实上<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他们中的大多数人甚至连这些名词的定义都搞不清楚<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >追随格雷厄姆与多德的投资人只关心两个变量--价值与价格<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >
      </p>
      <p class=index-module_textWrap_3ygOc>
        我总是惊奇地发现<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >如此众多的学术研究与技术分析臭味相投<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他们关注的都是股票价格和数量行为<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >你能想象整体收购一家企业只是因为其价格在前两周明显上涨-当然<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >关于价格与数量因素的研究泛滥成灾的原因在于电脑的普及应用<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >电脑制造出了无穷无尽的关于股价和成交数量的数据<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >这些研究毫无必要<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >因为它们毫无用途<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >这些研究出现的原因只是因为有大量的现成数据<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >而且学者们辛辛苦苦学会了玩弄数据的高深数学技巧<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >一旦人们掌握了那些技巧<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >不运用就会产生一种负罪感<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >即使这些技巧的运用根本没有任何作用甚至会有负作用<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >正如一位朋友所言<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >对于一个拿着斧子的人来说<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >什么东西看起来都像一颗钉子<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >
      </p>
      <p class="index-module_textWrap_3ygOc szhuang"><b>九位格雷厄姆和多德部落的超级投资者</b></p>
      <p class=index-module_textWrap_3ygOc>
        我认为<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >这群来自同一个智力家族的投资者们十分值得进一步的研究<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >顺便说一下<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >尽管所有的学术研究都关注类似于价格<span
          unicode="3001"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>、</span></span
        >数量<span
          unicode="3001"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>、</span></span
        >周期性<span
          unicode="3001"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>、</span></span
        >市值规模等因素对股价表现的影响<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >却从来没有证据表明学术界有兴趣研究这群非同寻常集中的价值导向的大赢家们所采用的投资策略<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >关于投资业绩记录的研究<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >我首先要从1954年到1956年间我们在格雷厄姆-纽曼公司<span
          unicode="ff08"
          class="biaodian cjk bd-open bd-jiya"
          ><span>（</span></span
        >Graham-Newman Corporation<span
          unicode="ff09"
          class="biaodian cjk bd-close bd-end bd-jiya"
          ><span>）</span></span
        >工作的四位同伴开始<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >我们总共只有四个人<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >我并不是从数以千计的投资人中挑选出这四个人的<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >我选修格雷厄姆的投资课程之后<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >要求进入这家公司无偿工作<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >但格雷厄姆却以我要价太高为由拒绝了我的要求<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他对价值因素考虑得非常严肃和认真<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >在我一再恳求之下<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他最后终于答应雇用我<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >当时公司有三位合伙人<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >还有我们四位当时对投资还不太在行的<span
          unicode="201c"
          class="biaodian cjk bd-open punct"
          >“</span
        >小学徒<span unicode="201d" class="biaodian cjk bd-close bd-end punct"
          >”</span
        ><span unicode="ff08" class="biaodian cjk bd-open bd-jiya"
          ><span>（</span></span
        >the<span unicode="201c" class="biaodian cjk bd-open punct">“</span
        >peasant<span
          unicode="201d"
          class="biaodian cjk bd-close bd-end punct"
          >”</span
        >level<span
          unicode="ff09"
          class="biaodian cjk bd-close bd-end bd-jiya bd-consecutive"
          ><span>）</span></span
        ><span
          unicode="3002"
          class="
            biaodian
            cjk
            bd-end bd-cop bd-hangable bd-jiya bd-consecutive
            end-portion
          "
          prev="bd-close bd-end"
          ><span>。</span></span
        >从1955年到1957年公司结束<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >我们四个人先后离开公司<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >目前我们能够追踪到其中三个人的投资记录<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >
      </p>
      <p class="index-module_textWrap_3ygOc szhuang">
        <b
          >1<span
            unicode="3001"
            class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
            ><span>、</span></span
          >沃特﹒斯科劳斯<span
            unicode="ff08"
            class="biaodian cjk bd-open bd-jiya"
            ><span>（</span></span
          >Walter Schloss<span
            unicode="ff09"
            class="biaodian cjk bd-close bd-end bd-jiya"
            ><span>）</span></span
          ></b
        >
      </p>
      <img
        src="../../../assets/img/gar5-1.jpg"
        class="ke_img"
      /><img
        src="../../../assets/img/gar5-2.jpg"
        class="ke_img"
      />
      <p class=index-module_textWrap_3ygOc>
        第一个案例<span unicode="ff08" class="biaodian cjk bd-open bd-jiya"
          ><span>（</span></span
        >见表1<span
          unicode="ff09"
          class="biaodian cjk bd-close bd-end bd-jiya"
          ><span>）</span></span
        >是沃特﹒斯科劳斯<span
          unicode="ff08"
          class="biaodian cjk bd-open bd-jiya"
          ><span>（</span></span
        >Walter Schloss<span
          unicode="ff09"
          class="biaodian cjk bd-close bd-end bd-jiya"
          ><span>）</span></span
        >的投资记录<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >沃特没有上过大学<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >但他在纽约金融学院<span
          unicode="ff08"
          class="biaodian cjk bd-open bd-jiya"
          ><span>（</span></span
        >theNew York Institute of Finance<span
          unicode="ff09"
          class="biaodian cjk bd-close bd-end bd-jiya"
          ><span>）</span></span
        >选修了格雷厄姆教授的夜间课程<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >沃特1955年离开了格雷厄姆-纽曼公司<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >在其后28年中<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他取得了以下投资业绩记录<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >亚当﹒史密斯
        <span unicode="ff08" class="biaodian cjk bd-open bd-jiya"
          ><span>（</span></span
        >Adam Smith<span
          unicode="ff09"
          class="biaodian cjk bd-close bd-end bd-jiya"
          ><span>）</span></span
        >经我介绍采访了沃特<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他在他的著作<span unicode="300a" class="biaodian cjk bd-open bd-jiya"
          ><span>《</span></span
        >超级投资大师<span
          unicode="300b"
          class="biaodian cjk bd-close bd-end bd-jiya bd-consecutive"
          ><span>》</span></span
        ><span
          unicode="ff08"
          class="biaodian cjk bd-open bd-jiya bd-consecutive end-portion"
          prev="bd-close bd-end"
          ><span>（</span></span
        >Supermoney<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >1972<span unicode="ff09" class="biaodian cjk bd-close bd-end bd-jiya"
          ><span>）</span></span
        >中对沃特是这样描述的<span
          unicode="ff1a"
          class="biaodian cjk bd-end bd-jiya"
          ><span>：</span></span
        >
      </p>
      <p class=index-module_textWrap_3ygOc>
        <span unicode="201c" class="biaodian cjk bd-open punct">“</span
        >他根本不与外界进行沟通<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >也没有任何获取有用信息的渠道<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >事实上<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >华尔街上根本没有人认识他<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他也根本不理会华尔街上的任何想法<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >他只是仔细查看股票手册上的有关数据<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >向公司索取年报<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他所做的一切仅此而已<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        ><span unicode="201d" class="biaodian cjk bd-close bd-end punct"
          >”</span
        >
      </p>
      <p class=index-module_textWrap_3ygOc>
        <span unicode="201c" class="biaodian cjk bd-open punct">“</span
        >巴菲特向我这样介绍沃特﹒斯科劳斯时<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >我内心在想<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他同时也是在描述他自己<span
          unicode="ff1a"
          class="biaodian cjk bd-end bd-jiya"
          ><span>：</span></span
        ><span unicode="2018" class="biaodian cjk bd-open punct">‘</span
        >他从来不曾忘记他是在管理别人的资金<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >而这种心态使他本来就十分强烈的风险厌恶态度变得更加强烈<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        ><span unicode="2019" class="biaodian cjk bd-close bd-end punct"
          >’</span
        >他为人非常正直<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >并且自我认识十分客观<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >资金对于他是现实客观的<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >股票同样是现实客观的--只有在符合安全边际原则的前提下<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >股票对他才有吸引力<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        ><span unicode="201d" class="biaodian cjk bd-close bd-end punct"
          >”</span
        >
      </p>
      <p class=index-module_textWrap_3ygOc>
        沃特的投资组合是多元化的<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他通常持有100多只股票<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >他知道如何发掘那些股票市值明显低于公司私有化价值的股票<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >这就是他要做的一切<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >他根本不考虑交易时间是不是1月份<span
          unicode="3001"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>、</span></span
        >是不是在周一<span
          unicode="3001"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>、</span></span
        >是不是选举之年<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >他只是这样想<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >如果一个企业价值1美元<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >而我能够用40美分买入<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >我很可能会取得很好的投资回报<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >他一次又一次地寻找这样的投资机会<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >他拥有的股票数目比我多得多--而且他和我不同的是<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他对公司业务的基本特点几乎都不感兴趣<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >我对沃特来说根本没有什么影响力<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >这正是他非常强大的个人品质之一--没有人能够影响他<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >
      </p>
      <p class="index-module_textWrap_3ygOc szhuang">
        <b
          >2<span
            unicode="3001"
            class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
            ><span>、</span></span
          >汤姆﹒科拿普<span
            unicode="ff08"
            class="biaodian cjk bd-open bd-jiya"
            ><span>（</span></span
          >Tom Knapp<span
            unicode="ff09"
            class="biaodian cjk bd-close bd-end bd-jiya"
            ><span>）</span></span
          ></b
        >
      </p>
      <p class=index-module_textWrap_3ygOc>
        第二个案例是汤姆-科拿普<span
          unicode="ff08"
          class="biaodian cjk bd-open bd-jiya"
          ><span>（</span></span
        >Tom Knapp<span
          unicode="ff09"
          class="biaodian cjk bd-close bd-end bd-jiya bd-consecutive"
          ><span>）</span></span
        ><span
          unicode="ff0c"
          class="
            biaodian
            cjk
            bd-end bd-cop bd-hangable bd-jiya bd-consecutive
            end-portion
          "
          prev="bd-close bd-end"
          ><span>，</span></span
        >他也是我在格雷厄姆-纽曼公司的同事<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >二战前<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他是普林斯顿大学化学专业的学生<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >二战结束后<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他退伍回来后终日在海滩上游荡<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >有一天<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >当他得知大卫-多德将在哥伦比亚大学开设夜间投资课程<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >汤姆以无学分方式选修了这门课程<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >他很快对投资产生了浓厚的兴趣<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >以至于正式注册进入哥伦比亚商学院学习<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >后来他获得了MBA学位<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >35年后<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >我打电话给汤姆核实我以上所说的事情<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >这时他仍然在海滩上游荡<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >唯一的不同是<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他现在拥有了这片海滩<span
          unicode="ff01"
          class="biaodian cjk bd-end bd-jiya"
          ><span>！</span></span
        >
      </p>
      <p class=index-module_textWrap_3ygOc>
        1986年<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >汤姆-科拿普与同样是格雷厄姆信徒的艾德-安德森<span
          unicode="ff08"
          class="biaodian cjk bd-open bd-jiya"
          ><span>（</span></span
        >Ed Anderson<span
          unicode="ff09"
          class="biaodian cjk bd-close bd-end bd-jiya"
          ><span>）</span></span
        >以及其他几位有共同投资理念的人合伙组建了特维帝-布朗合伙公司<span
          unicode="ff08"
          class="biaodian cjk bd-open bd-jiya"
          ><span>（</span></span
        >Tweedy, Browne Partners<span
          unicode="ff09"
          class="biaodian cjk bd-close bd-end bd-jiya bd-consecutive"
          ><span>）</span></span
        ><span
          unicode="ff0c"
          class="
            biaodian
            cjk
            bd-end bd-cop bd-hangable bd-jiya bd-consecutive
            end-portion
          "
          prev="bd-close bd-end"
          ><span>，</span></span
        >他们的投资业绩见表2<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >该公司取得以上投资记录的方式是进行高度分散化的投资组合<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他们偶尔也会并购企业取得控制权<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >但其被动式投资业绩与控制权投资的业绩基本相同<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >
      </p>
      <img
        src="../../../assets/img/gar5-3.jpg"
        class="ke_img"
      />
      <p class="index-module_textWrap_3ygOc szhuang">
        <b
          >3<span
            unicode="3001"
            class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
            ><span>、</span></span
          >沃伦﹒巴菲特<span
            unicode="ff08"
            class="biaodian cjk bd-open bd-jiya"
            ><span>（</span></span
          >Warren Buffett<span
            unicode="ff09"
            class="biaodian cjk bd-close bd-end bd-jiya"
            ><span>）</span></span
          ></b
        >
      </p>
      <p class=index-module_textWrap_3ygOc>
        格雷厄姆-纽曼公司第三位员工的投资业绩记录<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >他在1957年成立巴菲特合伙公司<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他所作出的最明智的决策就是在1969年结束合伙公司<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >从某种意义上讲<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >从此以后<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >伯克夏﹒哈撒韦公司在某种程度上成为合伙公司的延续<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >我无法给各位一个能够公正衡量伯克夏公司投资管理水平的单一业绩指标<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >但我认为<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >不论采用任何衡量指标<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >你都会发现伯克夏的投资业绩一直都令人相当满意<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >
      </p>
      <img
        src="../../../assets/img/gar5-4.jpg"
        class="ke_img"
      />
      <p class="index-module_textWrap_3ygOc szhuang"><b>4.比尔﹒鲁安</b></p>
      <p class=index-module_textWrap_3ygOc>
        红杉基金<span unicode="ff08" class="biaodian cjk bd-open bd-jiya"
          ><span>（</span></span
        >the Sequoia Fund<span
          unicode="ff09"
          class="biaodian cjk bd-close bd-end bd-jiya"
          ><span>）</span></span
        >的投资业绩记录<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >该基金经理是比尔鲁安<span
          unicode="ff08"
          class="biaodian cjk bd-open bd-jiya"
          ><span>（</span></span
        >Bill Ruane<span
          unicode="ff09"
          class="biaodian cjk bd-close bd-end bd-jiya bd-consecutive"
          ><span>）</span></span
        ><span
          unicode="ff0c"
          class="
            biaodian
            cjk
            bd-end bd-cop bd-hangable bd-jiya bd-consecutive
            end-portion
          "
          prev="bd-close bd-end"
          ><span>，</span></span
        >1951年我们在格雷厄姆的课程中结识<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >他从哈佛商学院毕业后进入华尔街工作<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他在工作中意识到自己需要接受一种真正的商业教育<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >于是报名参加了格雷厄姆在哥伦比亚大学的投资课程<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >1951年年初我们正是在那里相识<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >从1951年到1970年间<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >比尔所管理的资金规模相对于平均水平而言小得多<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >但投资业绩却远远超过平均水平<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >当我结束巴菲特合伙公司时<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >我问鲁安能否成立一家基金公司以吸收巴菲特合伙公司原来合伙人的资金<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >于是他就设立了红杉金<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >他设立这只基金的时候恰恰在我结束合伙公司之时<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >这是一个非常糟糕的市场时机<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >他正好碰上了一个双重市场<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >并且遭遇了价值投资者相对业绩表现非常差劲的困难时期<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >我非常高兴地说<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >我原来的合伙人不但继续与他相守<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >而且追加了更多的资金<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他取得如此优秀的投资业绩<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >当然让基金持有人非常满意<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >
      </p>
      <img
        src="../../../assets/img/gar5-5.jpg"
        class="ke_img"
      />
      <p class=index-module_textWrap_3ygOc>
        我并非事后诸葛亮<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >比尔是我当时推荐给合伙人的唯一人选<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >当时我就表示<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >如果他能取得高出标准普尔指数4个百分点的投资业绩就非常不错了<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >但尽管他所管理的资金规模不断扩大<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >比尔的投资业绩却远胜于此<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >资金规模越大<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >投资管理越困难<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >资金规模是投资业绩增长的绊脚石<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >虽然这并不意味着资金规模的扩大会使你的投资业绩无法超过平均水平<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >但超越平均水平的幅度会有所减小<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >如果你所管理的资金规模高达2万亿美元<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >这正好相当于整个股票市场的总市值<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >那么<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >你根本不可能取得超过平均水平的投资业绩<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >
      </p>
      <p class=index-module_textWrap_3ygOc>
        我必须补充说明一下<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >截至目前我们所考察的投资者的业绩记录<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他们各自的投资组合在整个投资期间实际上无一相同<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >这些投资人都是根据价格与价值间的差异来选股<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >但他们选择的股票却有很大的不同<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >沃特持股最多的公司都是实力强大的公司<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >如哈得逊纸业公司<span
          unicode="ff08"
          class="biaodian cjk bd-open bd-jiya"
          ><span>（</span></span
        >Hudson Pulp&amp; Paper<span
          unicode="ff09"
          class="biaodian cjk bd-close bd-end bd-jiya bd-consecutive"
          ><span>）</span></span
        ><span
          unicode="3001"
          class="
            biaodian
            cjk
            bd-end bd-cop bd-hangable bd-jiya bd-consecutive
            end-portion
          "
          prev="bd-close bd-end"
          ><span>、</span></span
        >掘都高地煤矿公司<span
          unicode="ff08"
          class="biaodian cjk bd-open bd-jiya"
          ><span>（</span></span
        >JeddoHighland Coal<span
          unicode="ff09"
          class="biaodian cjk bd-close bd-end bd-jiya bd-consecutive"
          ><span>）</span></span
        ><span
          unicode="3001"
          class="
            biaodian
            cjk
            bd-end bd-cop bd-hangable bd-jiya bd-consecutive
            end-portion
          "
          prev="bd-close bd-end"
          ><span>、</span></span
        >纽约暗色岩公司<span
          unicode="ff08"
          class="biaodian cjk bd-open bd-jiya"
          ><span>（</span></span
        >New York Trap Rock Company<span
          unicode="ff09"
          class="biaodian cjk bd-close bd-end bd-jiya bd-consecutive"
          ><span>）</span></span
        ><span
          unicode="ff0c"
          class="
            biaodian
            cjk
            bd-end bd-cop bd-hangable bd-jiya bd-consecutive
            end-portion
          "
          prev="bd-close bd-end"
          ><span>，</span></span
        >即使是偶尔阅读商业新闻的人也会对这些企业耳熟能详<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >特维帝﹒布朗公司所选择的股票则是那些名不见经传<span
          unicode="3001"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>、</span></span
        >默默无闻的公司<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >比尔的红杉基金选择的则是那些规模很大的企业<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >在他们各自的投资组合中<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >股票出现重叠的现象非常非常少<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >他们的投资业绩记录表明<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他们并非像前面抛硬币比赛中一个人喊出后其他15个人高声附和那样跟随别人进行投资<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他们在各自独立地进行不同的投资决策<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >
      </p>
      <p class="index-module_textWrap_3ygOc szhuang">
        <b
          >5<span
            unicode="3001"
            class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
            ><span>、</span></span
          >查理﹒芒格<span unicode="ff08" class="biaodian cjk bd-open bd-jiya"
            ><span>（</span></span
          >Charles Munger<span
            unicode="ff09"
            class="biaodian cjk bd-close bd-end bd-jiya"
            ><span>）</span></span
          ></b
        >
      </p>
      <p class=index-module_textWrap_3ygOc>
        表5的投资业绩记录来自于我的一位朋友<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他毕业于哈佛法学院<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >并且成立了一家律师事务所<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >我在1960年前后认识他<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >当时我对他说<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >律师作为一种业余爱好相当不错<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >但是他完全可以在投资中做得更好<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >于是<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他成立了一家投资合伙人公司<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >他的投资风格与沃特斯科劳斯完全相反<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他的投资组合集中于非常少数的证券<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >因此投资业绩的波动性很大<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >但他遵循的同样是寻找价值被低估股票的投资策略<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >他愿意接受投资业绩从 高峰到低谷的大幅震荡<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >正如结果所表明的那样<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他正好是那种心理能力完全适合集中投资的人<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >不用多说<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >这正是我在伯克夏公司的长期合作伙伴查理﹒芒格的投资业绩记录<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >不过<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >当他管理他自己的合伙公司时<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他的投资组合与我以及前面提到的投资人完全不同<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >
      </p>
      <img
        src="../../../assets/img/gar5-6.jpg"
        class="ke_img"
      /><img
        src="../../../assets/img/gar5-7.jpg"
        class="ke_img"
      />
      <p class="index-module_textWrap_3ygOc szhuang">
        <b
          >6<span
            unicode="3001"
            class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
            ><span>、</span></span
          >李克﹒古瑞恩<span
            unicode="ff08"
            class="biaodian cjk bd-open bd-jiya"
            ><span>（</span></span
          >Rick Guerin<span
            unicode="ff09"
            class="biaodian cjk bd-close bd-end bd-jiya"
            ><span>）</span></span
          ></b
        >
      </p>
      <p class=index-module_textWrap_3ygOc>
        投资业绩记录属于查理的一位好朋友<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >同样并非商学院毕业<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他毕业于南加州大学数学系<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >毕业后进入IBM<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >曾经做过一段时间的销售工作<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >在我认识查理之后不久<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >查理也认识了他<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >他就是这份投资业绩记录的创造者李克﹒古瑞恩<span
          unicode="ff08"
          class="biaodian cjk bd-open bd-jiya"
          ><span>（</span></span
        >Rick Guerin<span
          unicode="ff09"
          class="biaodian cjk bd-close bd-end bd-jiya bd-consecutive"
          ><span>）</span></span
        ><span
          unicode="3002"
          class="
            biaodian
            cjk
            bd-end bd-cop bd-hangable bd-jiya bd-consecutive
            end-portion
          "
          prev="bd-close bd-end"
          ><span>。</span></span
        >从1965年到1983年<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >标准普尔指数的复合成长率为316%<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >而李克﹒古瑞恩的投资业绩为22,200%<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >或许是由于没有商学院教育背景<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他竟然认为这在统计上具有显著意义<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >
      </p>
      <img
        src="../../../assets/img/gar5-8.jpg"
        class="ke_img"
      />
      <p class=index-module_textWrap_3ygOc>
        这里我们偏离一下主题<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >让我感到非常奇怪的是<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >对于以40美分的价格买进1美元纸币这种价值投资理念<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >人们要么是马上就接受<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >要么就是根本不接受<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >这就像接种预防注射一样<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >如果一个人无法马上理解这个投资理念<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >即使你以后对他谈上几年<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >并且出示各种投资业绩记录<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >结果仍然没有什么不同<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他还是不会接受<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >这种投资理念如此简单<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >可是他们就是无法领悟<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >像李克这样完全没有接受过正式商业教育的人<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >马上就领悟了价值投资策略<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >并且在五分钟之后就开始学以致用<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >我从来没有见过一个人是在10年之内才逐渐地皈依价值投资理念的<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >这似乎和智商或学术教育无关<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >要么顿悟<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >要么永远无法领悟<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >
      </p>
      <p class="index-module_textWrap_3ygOc szhuang">
        <b
          >7<span
            unicode="3001"
            class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
            ><span>、</span></span
          >斯坦﹒波尔米塔<span
            unicode="ff08"
            class="biaodian cjk bd-open bd-jiya"
            ><span>（</span></span
          >Stan Perlmeter<span
            unicode="ff09"
            class="biaodian cjk bd-close bd-end bd-jiya"
            ><span>）</span></span
          ></b
        >
      </p>
      <p class=index-module_textWrap_3ygOc>
        斯坦﹒波尔米塔<span
          unicode="ff08"
          class="biaodian cjk bd-open bd-jiya"
          ><span>（</span></span
        >Stan Perlmeter<span
          unicode="ff09"
          class="biaodian cjk bd-close bd-end bd-jiya"
          ><span>）</span></span
        >的投资业绩记录<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >他毕业于密西根大学艺术系<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >是波泽尔﹒雅各布斯<span
          unicode="ff08"
          class="biaodian cjk bd-open bd-jiya"
          ><span>（</span></span
        >Bozell&amp; Jacobs<span
          unicode="ff09"
          class="biaodian cjk bd-close bd-end bd-jiya"
          ><span>）</span></span
        >广告公司的合伙人之一<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >我和他的办公室恰好位于奥马哈市的同一栋大楼<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >1965年<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他发现我所从事的投资业比他从事的广告业前景更好<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >于是他离开了广告业<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >与李克﹒古瑞恩一样<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >斯坦﹒波尔米塔在五分钟之内就完全接受了价值投资理念<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >
      </p>
      <img
        src="../../../assets/img/gar5-9.jpg"
        class="ke_img"
      />
      <p class=index-module_textWrap_3ygOc>
        斯坦﹒波尔米塔所持有的股票与沃特﹒斯科劳斯不同<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >也与比尔持有的股票不同<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他们的投资记录表明<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他们各自独立进行不同的股票投资<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >但斯坦﹒波尔米塔每一次买进股票都是由于他确信将来卖出所获得的回报高于他所支付的买入价格<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >这是他唯一考虑的因素<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >他既不关心公司季度盈利预测是多少<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >也不关心公司明年收益预测如何<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他不在乎交易时间是星期几<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >也不关心任何机构的投资研究报告是如何评价这只股票的<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他对股票价格动能<span
          unicode="ff08"
          class="biaodian cjk bd-open bd-jiya"
          ><span>（</span></span
        >momentum<span
          unicode="ff09"
          class="biaodian cjk bd-close bd-end bd-jiya bd-consecutive"
          ><span>）</span></span
        ><span
          unicode="3001"
          class="
            biaodian
            cjk
            bd-end bd-cop bd-hangable bd-jiya bd-consecutive
            end-portion
          "
          prev="bd-close bd-end"
          ><span>、</span></span
        >成交量 等指标也丝毫不感兴趣<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他只关注一个问题<span
          unicode="ff1a"
          class="biaodian cjk bd-end bd-jiya"
          ><span>：</span></span
        >
        这个公司的价值是多少<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >
      </p>
      <p class="index-module_textWrap_3ygOc szhuang">
        <b
          >8<span
            unicode="3001"
            class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
            ><span>、</span></span
          >华盛顿邮报公司退休基金<span
            unicode="ff08"
            class="biaodian cjk bd-open bd-jiya"
            ><span>（</span></span
          >the Washington Post Company's Pension Fund<span
            unicode="ff09"
            class="biaodian cjk bd-close bd-end bd-jiya"
            ><span>）</span></span
          ></b
        >
      </p>
      <p class=index-module_textWrap_3ygOc>
        投资业绩记录分别属于我参与的两家退休基金<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >它们并非是从我所参与的十几种退休基金中选择出来的<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他是唯一两家我能够影响其投资决策的退休基金<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >在这两家基金中<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >我引导他们转变为价值导向的投资管理人<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >只有非常少数的基金是基于价值进行投资管理的<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >表8是华盛顿邮报公司退休基金<span
          unicode="ff08"
          class="biaodian cjk bd-open bd-jiya"
          ><span>（</span></span
        >the Washington Post Company'sPension Fund<span
          unicode="ff09"
          class="biaodian cjk bd-close bd-end bd-jiya"
          ><span>）</span></span
        >的投资业绩记录<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >几年之前<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他们委托一家大型银行管理基金<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >后来我建议他们聘请以价值为导向的基金经理<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >这样能够使投资业绩更好<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >
      </p>
      <img
        src="../../../assets/img/gar5-10.jpg"
        class="ke_img"
      />
      <p class=index-module_textWrap_3ygOc>
        正如你在投资记录中所看到的那样<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >从他们更换基金经理之后<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >其整体投资业绩在所有基金中一直名列前茅<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >华盛顿邮报公司要求基金经理人至少保持25%的资金投资于债券<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >而债券未必是基金经理人的投资选择<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >因此<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >我在表中也将其债券投资业绩包括在内<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >而这些数据表明他们其实并没有什么特别的债券专业技巧<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他们也从未这样吹嘘过自己<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >虽然有25%的资金投资于他们所不擅长的债券领域<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >从而拖累了他们的投资业绩<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >但其基金管理业绩水平仍然名列前一百名之内<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >华盛顿邮报公司退休基金的投资尽管并没有经过一个很长的市场低迷时期的考验<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >但仍然足以证明三位基金经理的许多投资决策并非后见之明<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >
      </p>
      <p class="index-module_textWrap_3ygOc szhuang">
        <b
          >9<span
            unicode="3001"
            class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
            ><span>、</span></span
          >FMC公司退休基金</b
        >
      </p>
      <p class=index-module_textWrap_3ygOc>
        投资业绩属于FMC公司退休基金<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >我本人没有管理过这家基金的一分钱<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >但我的确在1974年影响了他们的决策<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >说服他们选择以价值为导向的基金经理<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >在此之前<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他们采取与其他大型企业相同的方式来选择基金经理<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >在他们转向价值投资策略之后<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >其投资业绩目前在贝克退休基金调查报告<span
          unicode="ff08"
          class="biaodian cjk bd-open bd-jiya"
          ><span>（</span></span
        >the Becker survey of pension funds<span
          unicode="ff09"
          class="biaodian cjk bd-close bd-end bd-jiya"
          ><span>）</span></span
        >中超越其他同等规模基金而名列第一<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >1983年时<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >该基金共有8位任职1年以上的基金经理<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >其中7位累积投资业绩超过标准普尔指数<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >在此期 间<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >FMC基金的实际业绩表现与基金平均业绩表现的净回报差额是2.43亿美元<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >FMC将此归功于他们与众不同的基金经理选择倾向<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >这些基金经理未必会是我个人中意的选择<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >但他们都具有一个共同的特点<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >即基于价值来选择股票<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >
      </p>
      <img
        src="../../../assets/img/gar5-11.jpg"
        class="ke_img"
      />
      <p class=index-module_textWrap_3ygOc>
        以上这9项投资业绩记录都来自于格雷厄姆与多德部落的投资大赢家<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >我并非像事后诸葛亮那样以后见之明而从数千名投资者中挑选出这9个大赢家<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >也不是在朗读一群在中奖之前我根本不认识的彩票中奖者的名单<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >多年之前<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >我就根据投资决策的架构选择出他们进行研究<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >我知道他们接受过什么样的投资教育<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >在接触中也多少了解他们的智力<span
          unicode="3001"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>、</span></span
        >品质和性格<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >非常重要的是<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >我们必须要知道<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >这群人往往被大家想当然地认为只承受了远低于平均水平的风险<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >请注意他们在股市疲弱年份的投资业绩记录<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >尽管他们的投资风格不同<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >但其投资态度却完全相同--购买的是企业而非股票<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >他们当中有些人有时会整体收购企业<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >但是他们更多的只是购买企业的一小部分权益<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >不论购买企业的整体还是购买企业的一小部分权益<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >他们所持的态度都是完全相同的<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >他们中的有些人的投资组合中有几十种股票<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >有些 人则集中于少数几只股票<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >但是每个人的投资业绩都来自于利用企业股票市场价格与其内在价值之间的差异<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >
      </p>
      <p class="index-module_textWrap_3ygOc szhuang"><b>价值投资风险更小却收益更高</b></p>
      <p class=index-module_textWrap_3ygOc>
        我确信股票市场中存在着许多无效的现象<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >这些<span unicode="201c" class="biaodian cjk bd-open punct">“</span
        >格雷厄姆与多德部落<span
          unicode="201d"
          class="biaodian cjk bd-close bd-end punct"
          >”</span
        >的投资人之所以成功<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >就在于他们利用市场无效性所产生的价格与价值之间的差异<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >在华尔街上<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >股价会受到羊群效应的巨大影响<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >当最情绪化<span
          unicode="3001"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>、</span></span
        >最贪婪的或最沮丧的人决定股价的高低时<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >所谓市场价格是理性的说法很难令人信服<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >事实上<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >市场价格经常是荒谬愚蠢的<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >
      </p>
      <p class=index-module_textWrap_3ygOc>
        在价值投资中却恰恰相反<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >如果你以60美分买进1美元的纸币<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >其风险大于以40美分买进1美元的纸币<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >可是后者的预期报酬却更高<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >基于价值构造的投资组合<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >风险更小<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >预期报酬却高得多<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >
      </p>
      <p class=index-module_textWrap_3ygOc>
        我举一个简单的例子<span
          unicode="ff1a"
          class="biaodian cjk bd-end bd-jiya"
          ><span>：</span></span
        >
        1973年<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >华盛顿邮报公司总市值为8,000万美元<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >那时任何一天你都可以将其资产卖给十位买家中的任何一位<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >而且价格不会低于4亿美元<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >甚至还会更 高<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >该公司拥有华盛顿邮报<span
          unicode="3001"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>、</span></span
        >新闻周刊以及几家市场地位举足轻重的电视台<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >这些资产目前的市场价值高达20亿美元<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >因此<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >愿意支付4亿美元的买家并非疯狂之举<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >
      </p>
      <p class=index-module_textWrap_3ygOc>
        现在股价如果继续下跌<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >公司市值从8,000万美元跌到4,000万美元<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >其Beta值也会相应地上升<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >对于用Beta值衡量风险的人来说<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >价格跌得越低<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >意味着风险变得越大<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >这真是仙境中的爱莉丝一般的人间神话<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >我永远无法了解为什么用4,000万美元会比用8,000万美元购买价值4亿美元的风险更高<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >事实上<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >如果你能够买进好几只价值被严重低估的股票<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >而且精通公司估值<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >那么<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >以8,000万美元买入价值4亿美元的资产<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >特别是分别以800万美元的价格买进10种价值4,000万美元的资产<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >基本上是毫无风险的<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >因为你本人无法亲自管理4亿美元的资产<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >所以<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >你希望并确信能够找到诚实并且能干的管理者共同来管理公司<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >这并非一件困难之事<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >
      </p>
      <p class=index-module_textWrap_3ygOc>
        与此同时<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >你必须具有相应的知识<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >使你能够大致准确地评估企业的内在价值<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >你并不需要非常精确的评估数值<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >你所需要的就是格雷厄姆所说的价值大大超出价格所形成的安全边际<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >你不必试图以8,000万美元的价格购买价值8,300万美元的企业<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >你要让自己拥有一个很大的安全边际<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >当你建造桥梁时<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >你会确保这座桥能够承受3万磅的载重量<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >但你只准许载重1万磅的卡车通过<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >在投资中<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >你也应该遵循相同的安全边际原则<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >
      </p>
      <p class="index-module_textWrap_3ygOc strong"><b>价值投资将继续长期战胜市场</b></p>
      <p class=index-module_textWrap_3ygOc>
        你们当中的也许是那些商业头脑比较发达的人会怀疑我这番高谈阔论的动机何在<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >让更多的人转向价值投资必然会使价格与价值的差距更小<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >这会让我自己的投资获得的机会更少<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >我只能告诉你<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >早在50年前本格雷厄姆与多德写出<span
          unicode="300a"
          class="biaodian cjk bd-open bd-jiya"
          ><span>《</span></span
        >证券分析<span
          unicode="300b"
          class="biaodian cjk bd-close bd-end bd-jiya"
          ><span>》</span></span
        >一书时<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >价值投资策略就公之于众了<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >但我实践价值投资长达35年<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >却从没有发现任何大众转向价值投资的趋势<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >似乎人类有某种把本来简单的事情变得更加复杂的顽固本性<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >船舶将永远环绕地球航行<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >但相信地球平面理论的社会<span
          unicode="ff08"
          class="biaodian cjk bd-open bd-jiya"
          ><span>（</span></span
        >theFlat Earth Society<span
          unicode="ff09"
          class="biaodian cjk bd-close bd-end bd-jiya"
          ><span>）</span></span
        >仍旧繁荣昌盛<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >在股票市场中<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >价格与价值之间仍将继续保持着很大的差距<span
          unicode="ff0c"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>，</span></span
        >那些信奉格雷厄姆与多德价值投资策略的投资人仍将继续取得巨大的成功<span
          unicode="3002"
          class="biaodian cjk bd-end bd-cop bd-hangable bd-jiya"
          ><span>。</span></span
        >
      </p>
    </div>
    <p class="free">（来源：雪球 WithEric）</p>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>